import { render } from "./RealTimeNotice.vue?vue&type=template&id=6cb8234e"
import script from "./RealTimeNotice.vue?vue&type=script&lang=js"
export * from "./RealTimeNotice.vue?vue&type=script&lang=js"

import "./RealTimeNotice.vue?vue&type=style&index=0&id=6cb8234e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__